<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='1400px' center top='10vh'
             @close='dialogClose' :close-on-click-modal='false'>
    <div v-loading="pageLoading">
      <el-table
        :data='tableData'
        v-loading='tableLoading'
        style='width: 98%; margin: 10px auto;'
        border
        :header-cell-style='headerCellStyle'
        :span-method='objectSpanMethod'
      >
        <el-table-column label='收入端' align='center'>
          <el-table-column prop='standingBookMonth' label='台账月' align='center'
                           min-width='100px'/>
          <el-table-column prop='consignorId' label='委托商' align='center' min-width='200px'>
            <template slot-scope="scope">
              <el-select v-if="scope.row.consignorId"
                         v-model="scope.row.consignorId"
                         filterable size="mini" style="width:100%" placeholder="请选择委托商名称"
                         value-key="id"
                         @change="valChange('consignorId',scope.row.consignorId)">
                <el-option v-for="item in consignorOption" :key="item.id"
                           :label="item.customer_name"
                           :value="item.id"/>
              </el-select>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop='srYFRate' label='收入运费税率' align='center' min-width='100px'>
            <template slot-scope='scope'>
              <el-input-number
                v-if="scope.row.srYFRate>=0"
                size='mini'
                v-model='scope.row.srYFRate'
                :controls="false"
                @change="valChange('srYFRate',scope.row.srYFRate)"/>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop='yfprice' label='收入总运费' align='center' min-width='100px'>
            <template slot-scope='scope'>
              <el-input-number
                v-if="scope.row.yfprice>=0"
                size='mini'
                v-model='scope.row.yfprice'
                :controls="false"
                @change="valChange('yfprice',scope.row.yfprice)"/>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop='yfcount' label='收入运费数量' align='center' min-width='100px'/>
          <el-table-column prop='srZXRate' label='收入装卸费税率' align='center' min-width='100px'/>
          <el-table-column prop='zxprice' label='装卸费' align='center' min-width='100px'/>
          <el-table-column prop='zxcount' label='收入装卸费数量' align='center' min-width='100px'/>
          <el-table-column prop='startPlaceId' label='起始地' align='center' min-width='200px'>
            <template slot-scope='scope'>
              <el-cascader
                v-if="scope.row.startPlaceId"
                size='mini'
                v-model='scope.row.startPlaceId'
                placeholder='请选择起始地'
                :options='areaOption'
                :props='props' ref='delivery' filterable
                @change="valChange('startPlaceId',scope.row.startPlaceId)"
              />
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop='startPortId' label='起始港' align='center' min-width='200px'>
            <template slot-scope="scope">
              <el-select v-if="scope.row.startPortId"
                         v-model="scope.row.startPortId"
                         filterable size="mini" style="width:100%" placeholder="请选择起始港"
                         value-key="id" @change="valChange('startPortId',scope.row.startPortId)">
                <el-option v-for="item in portOption" :key="item.id" :label="item.portName"
                           :value="item.id"/>
              </el-select>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop='endPlaceId' label='交车地' align='center' min-width='200px'>
            <template slot-scope='scope'>
              <el-cascader
                v-if="scope.row.endPlaceId"
                size='mini'
                v-model='scope.row.endPlaceId'
                placeholder='请选择交车地'
                :options='areaOption'
                :props='props' ref='delivery' filterable
                @change="valChange('endPlaceId',scope.row.endPlaceId)"
              />
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop='endPortId' label='交车港' align='center' min-width='200px'>
            <template slot-scope="scope">
              <el-select v-if="scope.row.endPortId"
                         v-model="scope.row.endPortId"
                         filterable size="mini" style="width:100%" placeholder="请选择交车港"
                         value-key="id" @change="valChange('endPortId',scope.row.endPortId)">
                <el-option v-for="item in portOption" :key="item.id" :label="item.portName"
                           :value="item.id"/>
              </el-select>
              <div v-else></div>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label='成本端' align='center'>
          <el-table-column prop='supplierId' label='供应商' align='center' min-width='200px'>
            <template slot-scope="scope">
              <el-select v-if="scope.row.supplierId"
                         v-model="scope.row.supplierId"
                         filterable size="mini" style="width:100%" placeholder="请选择供应商"
                         value-key="id"
                         @change="costSideValChange('supplierId',scope.row.supplierId)">
                <el-option v-for="item in supplierOption" :key="item.id" :label="item.name"
                           :value="item.id"/>
              </el-select>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop='type' label='费用类型' align='center' min-width='100px'/>
          <el-table-column prop='zcRate' label='支出税率' align='center' min-width='100px'>
            <template slot-scope='scope'>
              <el-input-number
                v-if="scope.row.zcRate>=0"
                size='mini'
                v-model='scope.row.zcRate'
                :controls="false"
                @change="costSideValChange('zcRate',scope.row.zcRate)"/>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop='zcPrice' label='支出总金额' align='center' min-width='100px'>
            <template slot-scope='scope'>
              <el-input-number
                v-if="scope.row.zcPrice>=0"
                size='mini'
                v-model='scope.row.zcPrice'
                :controls="false"
                @change="costSideValChange('zcPrice',scope.row.zcPrice)"/>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop='zcCount' label='供应商数量' align='center' min-width='100px'/>
          <el-table-column prop='startPlaceId2' label='起始地' align='center' min-width='200px'>
            <template slot-scope='scope'>
              <el-cascader
                v-if="scope.row.startPlaceId2" size='mini'
                v-model='scope.row.startPlaceId2'
                placeholder='请选择起始地'
                :options='areaOption'
                :props='props' ref='delivery' filterable
                @change="costSideValChange('startPlaceId2',scope.row.startPlaceId2)"
              />
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop='startPortId2' label='起始港' align='center' min-width='200px'>
            <template slot-scope="scope">
              <el-select v-if="scope.row.startPortId2"
                         v-model="scope.row.startPortId2"
                         filterable size="mini" style="width:100%" placeholder="请选择起始港"
                         value-key="id"
                         @change="costSideValChange('startPortId2',scope.row.startPortId2)">
                <el-option v-for="item in portOption" :key="item.id" :label="item.portName"
                           :value="item.id"/>
              </el-select>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop='endPlaceId2' label='交车地' align='center' min-width='200px'>
            <template slot-scope='scope'>
              <el-cascader
                v-if="scope.row.endPlaceId2" size='mini'
                v-model='scope.row.endPlaceId2'
                placeholder='请选择交车地'
                :options='areaOption'
                :props='props' ref='delivery' filterable
                @change="costSideValChange('endPlaceId2',scope.row.endPlaceId2)"
              />
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop='endPortId2' label='交车港' align='center' min-width='200px'>
            <template slot-scope="scope">
              <el-select v-if="scope.row.endPortId2"
                         v-model="scope.row.endPortId2"
                         filterable size="mini" style="width:100%" placeholder="请选择交车港"
                         value-key="id"
                         @change="costSideValChange('endPortId2',scope.row.endPortId2)">
                <el-option v-for="item in portOption" :key="item.id" :label="item.portName"
                           :value="item.id"/>
              </el-select>
              <div v-else></div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class='btnContainer'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submitClick'>提交
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {adjustAccountDetail, adjustAccountSubmit} from '@/service/account';
import {applicationAreaInfo, customerInfoSelectList} from "@/service/getData";
import {portManagePageList} from "@/service/basicfile";
import {getSupplierList} from "@/service/DevOps";

export default {
  name: 'CorrectionAndAdjustment',
  data() {
    return {
      dialogTitle: '纠错调账',
      tableLoading: false,
      pageLoading: false,
      dialogVisible: false,
      submitLoading: false,
      tableData: [],
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      areaOption: [],
      portOption: [],
      supplierOption: [],
      consignorOption: [],
      props: {
        value: 'id',
        label: 'cityName',
        children: 'children'
      }
    };
  },
  methods: {
    /**
     * 纠错调账提交
     */
    async submitClick() {
      this.submitLoading = true;
      const params = this.tableData.map(item => {
        console.log(item);
        return {
          ...item,
          startPlaceId: item.startPlaceId && item.startPlaceId.length === 3 ? item.startPlaceId[2] : item.startPlaceId,
          endPlaceId: item.endPlaceId && item.endPlaceId.length === 3 ? item.endPlaceId[2] : item.endPlaceId,
          startPlaceId2: item.startPlaceId2 && item.startPlaceId2.length === 3 ? item.startPlaceId2[2] : item.startPlaceId2,
          endPlaceId2: item.endPlaceId2 && item.endPlaceId2.length === 3 ? item.endPlaceId2[2] : item.endPlaceId2,
        }
      })
      const {
        status,
        message,
      } = await adjustAccountSubmit(params);
      this.submitLoading = false;
      if (status !== 0) return this.$message.warning(message);
      this.$message.success(message);
      this.dialogClose();
    },
    // 打开弹出框
    dialogOpen(searchForm) {
      this.dialogVisible = true;
      this.getTableData(searchForm);
      this.getAreaList()
      this.portManagePageList()
      this.customerInfoSelectList()
      this.getSupplier()
    },
    /**
     * 获取表格数据
     */
    async getTableData(searchForm) {
      this.tableLoading = true;
      const data = await adjustAccountDetail(searchForm);
      if (data.status !== 0) return this.$message.warning(data.message)
      this.tableLoading = false;
      this.tableData = data.data.map(item => {
        return {
          ...item,
          startPlaceId: item.startPlaceId ? item.startPlaceId.split('/')[2] : null,
          endPlaceId: item.endPlaceId ? item.endPlaceId.split('/')[2] : null,
          startPlaceId2: item.startPlaceId2 ? item.startPlaceId2.split('/')[2] : null,
          endPlaceId2: item.endPlaceId2 ? item.endPlaceId2.split('/')[2] : null,
        }
      });
    },
    dialogClose() {
      this.dialogVisible = false;
      this.tableData = []
    },
    valChange(filed, value) {
      this.tableData.forEach(item => item[filed] = value)
    },
    costSideValChange(filed, value) {
      // this.tableData.forEach(item => item[filed] = value)
    },
    /**
     * 获取区域
     */
    async getAreaList() {
      this.pageLoading = true
      const {
        status,
        message,
        data,
      } = await applicationAreaInfo();
      if (status !== 0) return this.$message.warning(message);
      this.areaOption = data;
    },
    /**
     * 获取港口
     */
    async portManagePageList() {
      const {
        status,
        message,
        data,
      } = await portManagePageList({rows: 9999});
      if (status !== 0) return this.$message.warning(message);
      this.portOption = data.records;
    },
    /**
     * 获取委托商
     */
    async customerInfoSelectList() {
      const res = await customerInfoSelectList();
      if (res.status !== 0) this.$message.warning(res.message);
      this.consignorOption = res.data;
    },
    /**
     * 获取供应商
     */
    async getSupplier() {
      const {status, message, data} = await getSupplierList();
      this.pageLoading = false
      if (status !== 0) return this.$message.warning(message);
      this.supplierOption = data;
    },
    // 合并相同列
    objectSpanMethod({
                       row,
                       column,
                       rowIndex,
                       columnIndex,
                     }) {
      // data ：需要修改的列数和列的属性 第一列从0开始
      const data = [
        {columnIndex: 0, value: 'standingBookMonth'},
        {columnIndex: 1, value: 'consignorId'},
        {columnIndex: 2, value: 'srYFRate'},
        {columnIndex: 3, value: 'yfprice'},
        {columnIndex: 4, value: 'yfcount'},
        {columnIndex: 5, value: 'srZXRate'},
        {columnIndex: 6, value: 'zxprice'},
        {columnIndex: 7, value: 'zxcount'},
        {columnIndex: 8, value: 'startPlaceId'},
        {columnIndex: 9, value: 'startPortId'},
        {columnIndex: 10, value: 'endPlaceId'},
        {columnIndex: 11, value: 'endPortId'},
      ];
      for (let index = 0; index < data.length; index++) {
        if (columnIndex === data[index].columnIndex) {
          const _row = this.filterData(this.tableData, data[index].value)[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col,
          };
        }
      }
    },
    // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
    filterData(arr, value) {
      let spanOneArr = [];
      let concatOne = 0;
      arr.forEach((item, index) => {
        if (index === 0) {
          spanOneArr.push(1);
        } else {
          // name 修改
          if (item[value] === arr[index - 1][value]) {
            spanOneArr[concatOne] += 1;
            spanOneArr.push(0);
          } else {
            spanOneArr.push(1);
            concatOne = index;
          }
        }
      });
      return spanOneArr;
    },
  },
};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog {
  //max-height: 78vh;
  overflow: auto;
}

::v-deep {
  .el-input-number {
    width: 100%;
  }
}

.btnContainer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 13px;
  margin-top: 20px;

  button {
    margin: 0 15px;
  }
}
</style>
